export const SET_BOOK = "SET_BOOK"
export const GET_BOOK = "GET_BOOK"

export const FETCH_SINGLE_PDF_START = "FETCH_SINGLE_PDF_START"
export const FETCH_SINGLE_PDF_SUCCESS = "FETCH_SINGLE_PDF_SUCCESS"
export const FETCH_SINGLE_PDF_FAILED = "FETCH_SINGLE_PDF_FAILED"
